<template>
  <div class="cbox">
    <div class="w_100 h_100 bcontent flexStart borderbox" style="padding:20px 0;">
      <div class="h_100"
           style="flex-shrink:0;width:250px; overflow:auto; background-color:#E8EDF8;border-radius:4px;">
        <div class="w_100" style="background-color:#E8EDF8;border-radius:4px;">
          <div :class="['school', schoolId == 'all' ? 'ckd' : '']" @click="setSchool('all')">全部学校</div>
          <div :class="['school', schoolId == item.id ? 'ckd' : '']" @click="setSchool(item.id)"
               v-for="(item, idx) in SchoolList" :key="idx">{{ item.platform }}<!--<i v-if="!item.hasData"
							class="el-icon-star-on" style="color:orangered"></i>--></div>
        </div>

      </div>

      <div class="flex_1 h_100 ml20 flexCloumn" style="overflow:auto;">
        <div class="flexStart mb10">
          <el-select v-model="searchForm.major_type" size="small" placeholder="专业类别" clearable style="margin-right: 10px;" @change="getDataList">
            <el-option v-for="(mtype,index) in majorTypes" :label="mtype" :value="mtype" :key="index"></el-option>
          </el-select>
          <el-input v-model="searchForm.keyword" clearable size="small" placeholder="姓名/专业/手机号"></el-input>
          <el-button type="primary" size="small" icon="el-icon-search" @click="getDataList">搜索</el-button>
          <el-button v-if="schoolId == 'all'" type="primary" size="small" icon="el-icon-download" plain @click="downloadAll">下载全部</el-button>
          <el-button v-if="schoolId == 'all'" type="primary" size="small" icon="el-icon-download" plain @click="downloadSummaryTable">下载总表</el-button>
          <el-button v-else type="primary" size="small" icon="el-icon-download" plain @click="downloadTJB">下载技能鉴定统计表</el-button>
        </div>
        <el-table id="table" ref="table" :data="tableData" row-key="id" class="flex_1 mytable"
                  header-row-class-name="mytableheader"
                  stripe
                  border
                  height="100%" style="width:fit-content;width:100%;">
          <el-table-column type="index" label="序号" width="55px" align="center"></el-table-column>
          <el-table-column label="姓名" prop="stu_name" width="100" align="center"></el-table-column>
          <el-table-column label="性别" prop="gender" width="100" align="center"></el-table-column>
          <el-table-column label="年龄" prop="age" width="100" align="center"></el-table-column>
          <el-table-column label="学制" prop="xuezhi" width="100" align="center"></el-table-column>
          <el-table-column label="就业去向" prop="jyqx" width="100" align="center"></el-table-column>
          <el-table-column label="专业名称" prop="xibu_name" width="200" align="center"></el-table-column>
          <el-table-column label="专业类别" prop="zhuanye_type" width="200" align="center"></el-table-column>
          <el-table-column label="专业代码" prop="zydm" width="120" align="center"></el-table-column>
          <el-table-column label="职业技能等级/职业资格证" prop="prize_skill" width="220"
                           align="center"></el-table-column>
          <el-table-column fixed="right" label="操作" width="120">
            <template slot-scope="scope">
              <el-button @click="viewInfo(scope.row)" type="text" size="small">详情</el-button>
              <!--                <el-button v-if="$store.state.sysopened" @click="deleteRow(scope.row)" type="text" size="small">删除</el-button>-->
            </template>
          </el-table-column>
        </el-table>

        <div style="text-align:right;padding-top: 10px;">
          <el-pagination background @current-change="handlePageChange" :current-page="page.current_page"
                         :page-size="page.per_page" :total="page.count"
                         layout="total, prev, pager, next"></el-pagination>
        </div>

      </div>


    </div>
    <jiuyeinfo v-if="infoShow" :id="sxId" :showBack="false"></jiuyeinfo>
  </div>
</template>

<script>

import jiuyeinfo from "@/views/pages/com/jiuyeinfo.vue";

export default {
  components: {jiuyeinfo},
  data() {
    return {
      dialogShow: false,
      infoShow: false,
      dialogshow1: false,
      activeName: "first",
      schoolId: 'all',
      tjData: null,
      sxId: 0,
      SchoolList: [],
      tableData: [],
      searchForm: {},
      page: {
        count: 0,
        current_page: 1,
        per_page: 20,
        total_page: 0
      },
      majorTypes: [
        "农林牧渔大类",
        "资源环境与安全大类",
        "能源动力与材料大类",
        "土木建筑大类",
        "水利大类",
        "装备制造大类",
        "生物与化工大类",
        "轻工纺织大类",
        "食品药品与粮食大类",
        "交通运输大类",
        "电子与信息大类",
        "医药卫生大类",
        "财经商贸大类",
        "旅游大类",
        "文化艺术大类",
        "新闻传播大类",
        "教育与体育大类",
        "公安与司法大类",
        "公共管理与服务大类"
      ],
      timer: null,
    }
  },
  mounted() {
    this.getSchoolList()
    this.getDataList()

  },
  methods: {
    getSchoolList() {
      this.$http.post("/api/school_list").then(res => {
        this.SchoolList = res.data
      })
    },
    setSchool(id) {
      this.schoolId = 0;
      this.tjData = null;
      setTimeout(() => {
        this.schoolId = id
        this.getDataList()
      }, 200)

    },
    handleClick() {
      if (this.activeName == "second") {
        this.getDataList()

      }
    },
    getDataList() {
      this.$http.post("/api/jnjdzs_list", {
        tpmid: this.schoolId,
        page: this.page.current_page,
        pagesize: this.page.per_page,
        keyword: this.searchForm.keyword,
        major_type: this.searchForm.major_type
      }).then(res => {
        let tmp = []
        res.data.data.forEach(item => {
          item.certificates = item.certificates ? JSON.parse(item.certificates) : []
          tmp.push(item.certificates.length)
        })
        this.tableData = res.data.data;
        this.page = res.data.page
      })
    },
    handlePageChange(page) {
      this.page.current_page = page;
      this.getDataList();
    },
    viewInfo(e) {
      // e.keyword = this.searchForm.keyword
      // e.xibu_name = this.searchForm.xibu_name
      // e.class_name = this.searchForm.class_name

      this.sxId = e.id
      this.infoShow = true
    },
    uploadFiles(e) {
      if (e.src.indexOf("doc") > 0) {

        this.$http.post("/api/import_jiuyetj_word", {
          url: e.src
        }).then(res => {


          this.$message.success("导入成功")
          if (res.data.msg && res.data.msg.length > 0) {
            let html = ''
            for (let msg of res.data.msg) {
              html += "<div style='font-size:12px'>" + msg.msg + "</div>"
            }
            this.$alert(html, '未导入数据', {
              dangerouslyUseHTMLString: true
            });
          }
          this.dialogshow1 = false
          this.activeName = "second"
          this.getDataList()
          setTimeout(() => {
            this.handleClick()
          }, 500);


        })

      } else {
        this.$http.post("/api/import_jiuyefl_xls", {
          url: e.src
        }).then(res => {

          this.getDataList()
          this.$message.success("导入成功")
          if (res.data.msg.length > 0) {
            let html = ''
            for (let msg of res.data.msg) {
              html += "<div style='font-size:12px'>" + msg['巡访学生'] + ":" + msg.msg + "</div>"
            }
            this.$alert(html, '未导入数据', {
              dangerouslyUseHTMLString: true
            });
          }
          this.dialogShow = false
          this.activeName = "none"
          this.$nextTick(e => {
            this.activeName = "third"
          })


        })
      }
    },
    donwAll() {
      this.$http.post("/api/all_files_down", {
        school_id: this.schoolId
      }).then(res => {
        if (res.data.file) {

          window.open(res.data.file, "_blank")
        } else {
          this.$message({
            type: 'error',
            message: '该学校未上传统计表!'
          });
        }
      })

    },
    downloadTJB() {
      //window.open('/xls/南京市职业学校2025届毕业生技能鉴定情况统计表.xlsx')
      this.$http.post('/api/export_jnjdtjb', {tpmid: this.schoolId}).then(res => {
        window.open(res.data.url,'_blank')
      })
    },
    downloadAll() {
      const loadInstance = this.$loading({
        lock: true,
        text: '正在导出，请稍等...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
      this.$http.post('/api/export_jnjdtjb_all').then(res => {
        this.timer = setInterval(() => {
          this.$http.get('/api/progress_status?progressKey=' + res.data.progressKey).then(r => {
            let data = r.data.data
            if (data.indexOf('http') > -1) {
              window.open(data,'_blank')
              clearInterval(this.timer)
              loadInstance.close()
            } else if (data == 'failed') {
              clearInterval(this.timer)
              loadInstance.close()
              this.$message.error('导出失败')
            }
          }).catch(() => {
            clearInterval(this.timer)
            loadInstance.close()
          })
        },3000)
      }).catch(() => {
        loadInstance.close()
      })
    },
    downloadSummaryTable() {
      this.$http.post('/api/export_jnjdtjb_summary').then(res => {
        window.open(res.data.url,"_blank")
      })
    },
  },
  beforeDestroy() {
    clearInterval(this.timer)
  },
}
</script>

<style scoped>
.school {
  line-height: 30px;
  border-radius: 4px;
  cursor: pointer;
  padding: 5px 10px;
}

.school:hover {
  background-color: aliceblue;

}

.ckd {
  background-color: #547df2;
  color: #fff;
}

.ckd:hover {
  background-color: #547df2;
  color: #fff;
}
</style>